import Page from '../page';
import FormValidator from '../../helpers/form-validator';
import Google from '../../helpers/google';

export default class ContactIndex extends Page {
    constructor(...args) {
        super(...args);

        this._action = 'candiapro_contact';
        this._is_process = false;
        this._retrieveDOM();
        this._initTls();

        this._redirectURL();

    }

    _redirectURL() {
        let url = window.location.href;
        let cleanedUrl = url.split('?')[0];

        if( typeof url.split('?')[1] != 'undefined' ) {
            window.history.replaceState({}, 'Contact', url.split('?')[0] );
        }
    }

    _retrieveDOM() {

        this.dom.body = document.body;
        this.dom.strate = this.dom.page.querySelector('.js-strat');
        this.dom.formSuccess = this.dom.page.querySelector('.js-form-success');
        this.dom.input = [].slice.call(this.dom.page.querySelectorAll('.js-input'));
        this.dom.select = this.dom.page.querySelector('.js-select');
        this.dom.textarea = this.dom.page.querySelector('.js-textarea');
        this.dom.errorMessage = this.dom.page.querySelector('.js-error-message');
        this.dom.formBtn = this.dom.page.querySelector('.js-btn-send');
        this.dom.productCard = [].slice.call(this.dom.page.querySelectorAll('.js-product-card'));
        this.dom.categoryCard = [].slice.call(this.dom.page.querySelectorAll('.js-category-card'));
        this.dom.productClose = this.dom.page.querySelector('.js-product-close');
        this.dom.productContainer = this.dom.page.querySelector('.js-product-containter');

        this._Validator = new FormValidator({
            'inputs' : this.dom.input,
            'parent' : false
        });

    }

    bind() {

        for (let i = 0; i < this.dom.productCard.length; i++) {
            this.dom.productCard[i].addEventListener('click', this._toggleActive.bind(this));
        }

        for (let j = 0; j < this.dom.categoryCard.length; j++) {
            this.dom.categoryCard[j].addEventListener('click', this._toggleActive.bind(this));
        }

        this.dom.formBtn.addEventListener('click', this.process.bind(this));

        // this.dom.productClose.addEventListener('click', this._removeProductList.bind(this));

        this.dom.select.addEventListener('change', this._validateSelect.bind(this));
    }

    process(e) {

        if ( this._is_process == false ) {

            this._is_process = true;

            e.preventDefault();

            let data = new FormData();

            let validMessage = this._validateTextArea();
            let validSelect = this._validateSelect();

            if( this._Validator.isValid()) {

                let validCategoryProducts = this._validateCards(this.dom.categoryCard,'data-category-id');
                let validProducts = this._validateCards(this.dom.productCard,'data-product-label');

                if( validMessage && validSelect ) {

                    let formInputs = this._Validator.getData();

                    for(let item in formInputs) {
                        data.append(item, formInputs[item]);
                    }

                    data.append( 'message', this.dom.textarea.value );
                    data.append( 'country', this.dom.select.options[ this.dom.select.selectedIndex ].innerHTML );

                    if (validCategoryProducts) {
                        let categoryProducts = Object.assign({}, validCategoryProducts);
                        data.append('categoryProduct', JSON.stringify( categoryProducts ));
                    }

                    if (validProducts) {
                        let productsLabels = Object.assign({}, validProducts);
                        data.append('selectedProducts', this.dom.productContainer.getAttribute( 'data-product-id' ));
                        data.append('selectedProductsLabels', JSON.stringify( productsLabels ) );
                    }

                    this._request(data);
                } else {
                    this._is_process = false;
                }

            } else {
                this._is_process = false;
            }
        }
    }

    _request( data ) {

        this.dom.body.classList.add('loading');
        this.dom.formBtn.classList.add('loading');
        const xhr = new XMLHttpRequest();

        xhr.open('POST', '/ajax.php?action=' + this._action, true);

        xhr.onreadystatechange = function () {

            if(xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {

                this._response( (JSON.parse(xhr.response) ));

            }
            this._is_process = false;
            this.dom.formBtn.classList.remove('loading');
            this.dom.body.classList.remove('loading');
        }.bind(this);

        xhr.send(data);
    }

    //Check if TextArea is filled
    _validateTextArea() {
        this.dom.textarea.classList.remove('error');
        let value = this.dom.textarea.value;

        if( value.length > 3) {
            this.dom.textarea.classList.add('success');
            return true;

        } else {
            this.dom.textarea.classList.add('error');
            return false;
        }
    }

    //Check if Select has changed
    _validateSelect() {
        this.dom.select.classList.remove('error');
        let value = this.dom.select.value;

        if( value != '') {
            this.dom.select.classList.add('success');
            return true;

        } else {
            this.dom.select.classList.add('error');
            return false;
        }
    }

    //Check if Cards are Selected
    _validateCards( cards,id ) {
        let result = [];

        for (let i = 0; i < cards.length ; i++) {

            if (cards[i].classList.contains('active')) {
                let elementId = cards[i].getAttribute(id);
                result.push(elementId)
            }
        }
        return (result.length == 0 ) ? false : result;
    }

    _response( response ) {

        if( response.success == true ) {
            // window.location.href = response.data.redirect;
            this.dom.strate.classList.add('success');
            Google.pushCustomTracker('Contact', 'Send');
        } else {
            this._is_process = false;

            /** Bad email **/
            if( response.data.error == 'invalid_email' )
            {
                this.dom.errorMessage.innerHTML = 'L\'adresse email n\'est pas valide';
                this.dom.errorMessage.classList.add('show');
            }
        }
    }

    //// PRODUCTS HANDLER ////

    //Toggle Active class
    _toggleActive( event ) {
        let element = event.currentTarget;
        if( !element.classList.contains('active') ) {
            element.classList.add('active');
        } else {
            element.classList.remove('active');
        }
    }

    //Set Active ProductCard
    _setActiveProduct( event ) {
        let element = event.currentTarget;
        this._removeActiveProductCard();
        element.classList.add('active');
    }

    //Remove Active ProductCard
    _removeActiveProductCard() {
        for (let i = 0; i < this.dom.productCard.length; i++) {
            this.dom.productCard[i].classList.remove('active')
        }
    }

    //Remove ProductList
    _removeProductList() {
        this.dom.productContainer.style.display = 'none';
    }
    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/contact/contact-index.js